import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";

function Projects() {
  return (
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Projects </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects and learning experiences that reflect my
            interests in software engineering, web development, and data analytics.
          </p>

          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                  imgPath={chatify}
                  isBlog={false}
                  title="Personal Portfolio Website"
                  description="Customized an open-source React portfolio template into a personal website to showcase my education, work experience, technical skills, resume, and selected projects. Updated page content, routing sections, project cards, assets, and social links to build a professional portfolio for job applications."
                  ghLink="https://github.com/yichengzou"
                  demoLink="#"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                  imgPath={editor}
                  isBlog={false}
                  title="HTML, CSS, and JavaScript Web Development"
                  description="Completed a front-end web development project using HTML, CSS, and JavaScript. Built responsive and interactive web pages while gaining practical experience in page layout, styling, user interaction, and dynamic website functionality."
                  ghLink="https://github.com/yichengzou"
                  demoLink="#"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                  imgPath={leaf}
                  isBlog={false}
                  title="Python for Software Engineering Bootcamp"
                  description="Completed a Python software engineering bootcamp focused on object-oriented programming, debugging, testing, version control, and building scalable software solutions. Strengthened my foundation in modern software development practices."
                  ghLink="https://github.com/yichengzou"
                  demoLink="#"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                  imgPath={emotion}
                  isBlog={false}
                  title="Business Analytics & Reporting"
                  description="Applied Python, SQL, Power BI, and analytical methods to explore business data, generate insights, and support decision-making through reports and visualizations. This project reflects my background in business analytics, quantitative decision-making, and data-driven problem solving."
                  ghLink="https://github.com/yichengzou"
                  demoLink="#"
              />
            </Col>
          </Row>
        </Container>
      </Container>
  );
}

export default Projects;
